// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"8d11fabd","268":"368a96fe","884":"78d27913"}[chunkId] + ".chunk.css";
};